export default "__VITE_ASSET__SlkQjQvI__"